/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Spinner, Alert } from "react-bootstrap";
import api from "../../utils/api";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import he from "he";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import AddQuestion from "../questions/AddQuestion";
import "react-toastify/dist/ReactToastify.css";
import { FiClock } from "react-icons/fi";

const Random = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [questionIds, setQuestionIds] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [levels, setLevels] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [templateSubjectIds, setTemplateSubjectIds] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingQuestionId, setEditingQuestionId] = useState(null);

  const [questionTypes, setQuestionTypes] = useState([]);
  const [selectedQuestionTypes, setSelectedQuestionTypes] = useState([]);
  const [templateQuestionTypeIds, setTemplateQuestionTypeIds] = useState([]);

  const [showDistributionModal, setShowDistributionModal] = useState(false);
  const [distributionData, setDistributionData] = useState([]);

  const [templateSections, setTemplateSections] = useState([]);
  const [distributionRows, setDistributionRows] = useState([]);

  const [replacingId, setReplacingId] = useState(null);
  const [prevPapers, setPrevPapers] = useState({});
  const [loadingPrevPaper, setLoadingPrevPaper] = useState(null);

  const [questionTypeSummary, setQuestionTypeSummary] = useState([]);
  const [paperStats, setPaperStats] = useState([]);
  const [subjectConfigs, setSubjectConfigs] = useState([]);

  const [showChapterSummaryModal, setShowChapterSummaryModal] =
    useState(false);

  const [chapterWiseSummary, setChapterWiseSummary] =
    useState([]);

  const [warnings, setWarnings] = useState([]);
  const [topicsBySubject, setTopicsBySubject] =
    useState({});


  useEffect(() => {

    fetchLevel();
    fetchAdded();
  }, []);

  useEffect(() => {

    if (levels.length > 0) {

      fetchTemplateDetails();
    }

  }, [levels]);

  useEffect(() => {
    if (selectedSubject.length > 0) {
      fetchChapters(selectedSubject);
    } else {
      setChapters([]);
      setSelectedChapter([]);
      setTopics([]);
      setSelectedTopic([]);
    }
  }, [selectedSubject]);

  const handleCountChange = (index, value) => {

    const updated = [...distributionRows];

    updated[index].count = value;

    setDistributionRows(updated);
  };

  useEffect(() => {

    if (templateQuestionTypeIds.length > 0) {

      fetchQuestionType();
    }

  }, [templateQuestionTypeIds]);

  useEffect(() => {
    if (selectedSubject.length > 0 && selectedChapter.length > 0) {
      fetchTopics(selectedSubject, selectedChapter);
    } else {
      setTopics([]);
      setSelectedTopic([]);
    }
  }, [selectedSubject, selectedChapter]);

  async function fetchTemplateDetails() {

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const fd = new FormData();

    fd.append("programType", "getTemplateDetailsInAddQuestions");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", id);

    try {

      const response = await api.post("paper/paperCurl", fd);


      console.log("template details", response);

      const templateDetails = response.data?.data?.[0]?.details;

      if (templateDetails) {

        const parsed = JSON.parse(templateDetails);

        const sections = parsed.sections || {};

        setTemplateSections(Object.values(sections));

        const generatedRows = [];
        const questionTypeSet = new Set();

        Object.values(sections).forEach((section) => {

          const questionTypeIds = section.questionType
            ?.split(",")
            .map((q) => q.trim()) || [];

          // STORE TEMPLATE QUESTION TYPES
          questionTypeIds.forEach((id) => {
            questionTypeSet.add(String(id));
          });

          Object.values(section.subjects || {}).forEach((subject) => {

            questionTypeIds.forEach((questionTypeId) => {



              levels.forEach((level) => {

                generatedRows.push({
                  sectionNumber: section.sectionNumber,

                  subjectId: String(subject.subjectId),
                  subjectName: subject.subjectName,

                  questionTypeId: String(questionTypeId),
                  questionTypeName: "",
                  levelId: String(level.id),
                  levelName: level.levelName,

                  count: "",
                });

              });

            });

          });

        });

        setTemplateQuestionTypeIds(
          Array.from(questionTypeSet)
        );

        const generatedSubjects = [];

        Object.values(sections).forEach((section) => {

          Object.values(section.subjects || {}).forEach((subject) => {

            generatedSubjects.push({
              sectionNumber: section.sectionNumber,

              subjectId: Number(subject.subjectId),

              subjectName: subject.subjectName,

              totalQuestions: Number(
                subject.noOfQuestions || 0
              ),

              levels: {},

              chapters: [],

              topics: [],

              showChapters: false,

              showTopics: false,
            });

          });

        });

        setSubjectConfigs(generatedSubjects);
        const allSubjectIds =
          generatedSubjects.map(
            (item) => item.subjectId
          );

        fetchSubjects(allSubjectIds);

        fetchChapters(allSubjectIds);
      }

    } catch (error) {

      console.log(error);
    }
  }

  async function fetchSubjects(templateSubjectIds = []) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getSubjectOnChange";
      const role = localStorage.getItem("role");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("role", role);

      const subjectResponse = await api.post("onchange/onchangeCurl", fd);

      console.log("subject", subjectResponse)



      const fetchedSubjects = Array.isArray(subjectResponse.data.data)
        ? subjectResponse.data.data
        : [];

      const filteredSubjects = fetchedSubjects.filter((subject) =>
        templateSubjectIds.includes(Number(subject.id))
      );

      setSubjects(filteredSubjects);
    } catch (error) {
      console.error("Error fetching subjects:", error);
      setSubjects([]);
    }
  }
  async function fetchChapters(subjectIds) {
    if (!subjectIds || subjectIds.length === 0) {
      setChapters([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getChapterOnChangeMultiple";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      subjectIds.forEach((subjectId, index) => {
        fd.append(`subjectId[${index}]`, subjectId);
      });

      const chapterResponse = await api.post("onchange/onchangeCurl", fd);
      console.log("chapter", chapterResponse)
      if (Array.isArray(chapterResponse.data.data)) {
        setChapters(chapterResponse.data.data);
      } else {
        setChapters([]);
      }
    } catch (error) {
      setChapters([]);
    }
  }

  async function fetchTopics(subjectIds, chapterIds) {
    if (
      !subjectIds ||
      subjectIds.length === 0 ||
      !chapterIds ||
      chapterIds.length === 0
    ) {
      setTopics([]);
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getTopicOnChangeMultiple";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      subjectIds.forEach((subjectId, index) => {
        fd.append(`subjectId[${index}]`, subjectId);
      });

      chapterIds.forEach((chapterId, index) => {
        fd.append(`chapterId[${index}]`, chapterId);
      });

      const topicResponse = await api.post("onchange/onchangeCurl", fd);
      console.log("TOPICS", topicResponse)
      if (Array.isArray(topicResponse.data.data)) {
        setTopicsBySubject((prev) => ({
          ...prev,
          [subjectIds[0]]: topicResponse.data.data || [],
        }));
      } else {
        setTopics([]);
      }
    } catch (error) {
      setTopics([]);
    }
  }

  async function fetchLevel() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getLevelDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("level/levelCurl", fd);
      if (Array.isArray(response.data.getLevelDetails)) {
        setLevels(response.data.getLevelDetails);
      } else {
        setLevels([]);
      }
    } catch (error) {
      console.error("Error fetching levels:", error);
      setLevels([]);
    }
  }

  async function fetchQuestionType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getQuestionTypeDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("questionType/questionTypeCurl", fd);

      console.log("questionType", response);

      if (Array.isArray(response?.data?.getQuestionTypeDetails)) {

        const allQuestionTypes = response.data.getQuestionTypeDetails;

        // FILTER USING TEMPLATE IDS
        const filteredQuestionTypes = allQuestionTypes.filter((type) =>
          templateQuestionTypeIds.includes(String(type.id))
        );

        setQuestionTypes(filteredQuestionTypes);

      } else {
        setQuestionTypes([]);
      }

    } catch (error) {
      console.log(error);
      setQuestionTypes([]);
    }
  }

  const handleQuestionCountChange = (
    subjectId,
    value
  ) => {

    setSubjectConfigs((prev) =>
      prev.map((item) =>
        item.subjectId === subjectId
          ? {
            ...item,
            totalQuestions: value,
          }
          : item
      )
    );

  };



  useEffect(() => {

    if (
      questionTypes.length > 0 &&
      distributionRows.length > 0
    ) {

      const updatedRows = distributionRows.map((row) => {

        const matchedQuestionType =
          questionTypes.find(
            (qt) =>
              String(qt.id) ===
              String(row.questionTypeId)
          );

        return {
          ...row,

          questionTypeName:
            matchedQuestionType?.questionType || "",
        };
      });

      setDistributionRows(updatedRows);
    }

  }, [questionTypes]);



  const questionTypeOptions = questionTypes.map((type) => ({
    value: type.id,
    label: `${type.questionType}`,
  }));

  const handleQuestionTypeChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((opt) => String(opt.value))
      : [];

    setSelectedQuestionTypes(values);
  };

  async function fetchSingleQuestion(questionId) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      // Question API
      const fd1 = new FormData();
      fd1.append("loggedInUser", loggedInUser);
      fd1.append("token", token);
      fd1.append("programType", "getQuestionDetailsMain");
      fd1.append("search", questionId);

      const questionResponse = await api.post(
        "question/questionCurl",
        fd1
      );

      const updatedQuestion =
        questionResponse?.data?.questions?.[0];

      if (!updatedQuestion) return;

      // Options API
      const fd2 = new FormData();
      fd2.append("loggedInUser", loggedInUser);
      fd2.append("token", token);
      fd2.append(
        "programType",
        "getOptionsAndAnsForQuestion"
      );
      fd2.append("questionId", questionId);

      const answerResponse = await api.post(
        "question/questionCurl",
        fd2
      );

      const answerData = answerResponse?.data || {};

      updatedQuestion.options =
        answerData.options || [];

      updatedQuestion.answer =
        answerData.answer || "";

      updatedQuestion.optionId =
        answerData.optionId || "";

      updatedQuestion.explanation =
        answerData.explanation || "";

      setQuestions((prev) =>
        prev.map((q) =>
          String(q.id) === String(updatedQuestion.id)
            ? {
              ...q,
              ...updatedQuestion,
            }
            : q
        )
      );
    } catch (error) {
      console.error(
        "Error fetching single question:",
        error
      );
    }
  }

  async function fetchSingleQuestionAnswer(questionId) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getOptionsAndAnsForQuestion");
      fd.append("questionId", questionId);

      const response = await api.post("question/questionCurl", fd);

      console.log("Single Question Answer Response:", response);
    } catch (error) {
      console.error("Error fetching single question:", error);
    }
  }

  const handleFetchPrev = async (questionId) => {
    try {
      setLoadingPrevPaper(questionId);

      const fd = new FormData();

      fd.append("programType", "getPapersByQuestionId");
      fd.append(
        "loggedInUser",
        localStorage.getItem("loggedInUser")
      );
      fd.append(
        "token",
        localStorage.getItem("authToken")
      );
      fd.append("questionId", questionId);

      const res = await api.post(
        "picQuestion/picQuestionCurl",
        fd
      );

      if (
        res?.data?.status === false ||
        res?.data?.success === false
      ) {
        toast.error(
          res?.data?.message || "Something went wrong"
        );
        return;
      }

      setPrevPapers((prev) => ({
        ...prev,
        [questionId]: res.data.papers || [],
      }));
    } catch (err) {
      console.error(err);

      toast.error(
        err?.response?.data?.message ||
        "Failed to fetch previous papers"
      );
    } finally {
      setLoadingPrevPaper(null);
    }
  };

  const handleCloseEdit = (updatedId) => {
    setShowEditModal(false);

    if (updatedId) {
      fetchSingleQuestion(updatedId);

    }
  };

  async function fetchAdded() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const fd = new FormData();
    fd.append("programType", "getPaperDetailsWithSubjectWiseCount");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("paperId", id);

    try {
      const response = await api.post("question/paperImport", fd);
      console.log("Paper Stats Response:", response.data);

      if (response?.data?.status) {
        // Look for sections in the root of data, with a fallback to templateDetails
        const sectionsData = response.data.sections || response.data.templateDetails?.sections || [];
        setPaperStats(sectionsData);
      }
    } catch (error) {
      console.error("Error fetching added counts:", error);
    }
  }

  async function fetchRandomQuestions() {
    const loggedInUser =
      localStorage.getItem("loggedInUser");

    const token =
      localStorage.getItem("authToken");

    const groupedDistribution =
      subjectConfigs
        .filter(
          (subject) =>
            Number(subject.totalQuestions) > 0
        )
        .map((subject) => ({
          subjectId: Number(subject.subjectId),

          totalQuestions: Number(
            subject.totalQuestions || 0
          ),

          levels: subject.levels || {},

          chapters: subject.chapters || [],

          topics: subject.topics || [],
        }));

    if (groupedDistribution.length === 0) {
      toast.warning(
        "Please enter question counts"
      );
      return;
    }

    const fd = new FormData();

    fd.append(
      "programType",
      "generateRandomQuestionsWithDistribution2"
    );

    fd.append(
      "loggedInUser",
      loggedInUser
    );

    fd.append("token", token);

    fd.append("paperId", id);

    fd.append(
      "distribution",
      JSON.stringify(groupedDistribution)
    );

    console.log(
      "DISTRIBUTION SENT",
      groupedDistribution
    );

    try {
      setIsGenerating(true);

      const response = await api.post(
        "question/paperImport",
        fd
      );

      console.log(response);

      if (response.data.status) {
        setQuestions(
          response?.data?.questions || []
        );

        setQuestionIds(
          response?.data?.questionIds || []
        );

        setQuestionTypeSummary(
          response?.data
            ?.questionTypeWiseSummary || []
        );

        setChapterWiseSummary(
          response?.data
            ?.chapterWiseSummary || []
        );

        setWarnings(
          response?.data?.warnings || []
        );

        toast.success(
          `Successfully generated ${response?.data?.questions
            ?.length || 0
          } questions`
        );
      } else {
        toast.error(
          response.data.message
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(
        "Failed to generate questions"
      );
    } finally {
      setIsGenerating(false);
    }
  }
  const handleDistributionCountChange = (index, value) => {

    const updated = [...distributionData];

    updated[index].count = value;

    setDistributionData(updated);
  };

  async function generateQuestionsFromDistribution() {

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const fd = new FormData();

    fd.append("programType", "generateRandomQuestionsWithDistribution2");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("paperId", id);

    fd.append("distribution", JSON.stringify(distributionData));

    fd.entries().forEach(([key, value]) => {
      console.log(`${key}:`, value);
    });

    console.log("FINAL DISTRIBUTION SENT");

    console.log(distributionData);

    try {

      setIsGenerating(true);

      const response = await api.post("question/paperImport", fd);

      console.log("Random Questions Response:", response);

      if (response.data.status === true) {

        setQuestions(response?.data?.questions || []);
        setQuestionIds(response?.data?.questionIds || []);

        toast.success(
          `Successfully generated ${response?.data?.questions?.length || 0
          } questions`
        );

        setShowDistributionModal(false);

      } else {

        toast.error(response.data.message || "Failed to generate questions.");
      }

    } catch (error) {

      console.error("Error fetching questions:", error);

      toast.error(
        "An error occurred while generating questions."
      );

    } finally {

      setIsGenerating(false);
    }
  }

  const handleReplaceQuestion = async (
    questionId,
    index
  ) => {

    try {

      setReplacingId(questionId);

      const loggedInUser =
        localStorage.getItem("loggedInUser");

      const token =
        localStorage.getItem("authToken");

      /*
        SAME DISTRIBUTION FORMAT
      */

      const filteredRows = distributionRows.filter(
        (row) => Number(row.count) > 0
      );

      // --- NEW TRANSFORMATION LOGIC STARTS HERE ---
      const groupedDistribution = [];

      filteredRows.forEach((row) => {
        let subjectGroup = groupedDistribution.find(
          (item) => String(item.subjectId) === String(row.subjectId)
        );

        if (!subjectGroup) {
          subjectGroup = {
            subjectId: Number(row.subjectId),
            questionTypes: [],
          };
          groupedDistribution.push(subjectGroup);
        }

        let qtGroup = subjectGroup.questionTypes.find(
          (qt) => String(qt.questionTypeId) === String(row.questionTypeId)
        );

        if (!qtGroup) {
          qtGroup = {
            questionTypeId: String(row.questionTypeId),
            levels: [],
          };
          subjectGroup.questionTypes.push(qtGroup);
        }

        qtGroup.levels.push({
          levelId: Number(row.levelId),
          count: Number(row.count),
        });
      });
      const fd = new FormData();

      fd.append(
        "programType",
        "replaceRandomQuestion"
      );

      fd.append(
        "loggedInUser",
        loggedInUser
      );

      fd.append("token", token);

      fd.append("paperId", id);

      fd.append("questionId", questionId);

      fd.append(
        "distribution",
        JSON.stringify(groupedDistribution)
      );

      const response = await api.post(
        "question/paperImport",
        fd
      );

      console.log(
        "Replace Response",
        response
      );

      if (response?.data?.status) {

        const newQuestion =
          response.data.question;

        const oldQuestionId =
          response.data.replacedQuestionId;

        // PREVENT DUPLICATE
        const alreadyExists = questions.some(
          (q) =>
            String(q.id) ===
            String(newQuestion.id)
        );

        if (alreadyExists) {

          toast.error(
            "⚠️ Same question already exists"
          );

          return;
        }

        // REPLACE QUESTION IN UI
        setQuestions((prev) => {

          const updated = [...prev];

          updated[index] = newQuestion;

          return updated;
        });

        // UPDATE IDS
        setQuestionIds((prevIds) => {

          return prevIds.map((qid) =>
            String(qid) ===
              String(oldQuestionId)
              ? String(newQuestion.id)
              : qid
          );

        });

        toast.success(
          "✅ Question replaced successfully"
        );

      } else {

        toast.error(
          response.data.message ||
          "Failed to replace question"
        );
      }

    } catch (error) {

      console.log(error);

      toast.error(
        "Error replacing question"
      );

    } finally {

      setReplacingId(null);
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();

    if (questionIds.length === 0) {
      toast.warning("No questions to submit. Please generate questions first.");
      return;
    }


    setSubmitting(true);

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    const fd = new FormData();
    fd.append("programType", "generateQuestionsFromQuestionIds");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("paperId", id);

    questionIds.forEach((id) => {
      fd.append(`questionIds[]`, id);
    });

    try {
      const response = await api.post("question/paperImport", fd);
      console.log("Submitted Questions Response:", response);

      if (response.data.status === true) {
        toast.success(response.data.data);

        // Fetch fresh counts immediately!
        fetchAdded();

        setTimeout(() => {

          /*
            RESET QUESTIONS
          */

          setQuestions([]);

          setQuestionIds([]);

          setQuestionTypeSummary([]);
          setWarnings([]);
          /*
            RESET FILTERS
          */

          setSelectedSubject([]);

          setSelectedChapter([]);

          setSelectedTopic([]);

          setSelectedLevel([]);

          setSelectedQuestionTypes([]);

          /*
            RESET ALL COUNTS IN TABLE
          */

          setDistributionRows((prev) =>
            prev.map((row) => ({
              ...row,
              count: "",
            }))
          );

          /*
            FETCH UPDATED SUBJECT COUNTS
          */

          fetchAdded();

        }, 1000);
      }


    } catch (error) {
      console.error("Error submitting questions:", error);
      toast.error("An error occurred while submitting questions.");
    }
    finally {
      setSubmitting(false);
    }
  }

  // 1. Add this state near your other useState declarations
  const [expandedChapters, setExpandedChapters] = useState({});

  // 2. Add these handler functions before your return() statement
  const toggleChapterExpansion = (chapterId) => {
    setExpandedChapters((prev) => ({
      ...prev,
      [chapterId]: !prev[chapterId],
    }));
  };

  const handleNestedTopicSelection = (subjectId, chapterId, selectedOptions) => {
    const selectedTopicIds = selectedOptions
      ? selectedOptions.map((opt) => Number(opt.value))
      : [];

    setSubjectConfigs((prev) =>
      prev.map((item) => {
        if (item.subjectId === subjectId) {
          const chapterTopics =
            topicsBySubject[subjectId]?.filter(
              (t) => Number(t.chapterId) === chapterId
            ) || [];
          const chapterTopicIds = chapterTopics.map((t) => Number(t.id));

          const otherTopics = item.topics.filter(
            (id) => !chapterTopicIds.includes(id)
          );

          return {
            ...item,
            topics: [...otherTopics, ...selectedTopicIds],
          };
        }
        return item;
      })
    );
  };

  const renderLatexText = (text) => {
    if (!text) return null;

    const decodedText = he.decode(text);
    const latexAndImageRegex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

    const parts = [];
    let lastIndex = 0;

    decodedText.replace(
      latexAndImageRegex,
      (match, inlineLatex, blockLatex, quote, imageSrc, alignContent, index) => {
        if (index > lastIndex) {
          parts.push(decodedText.slice(lastIndex, index));
        }

        if (imageSrc) {
          parts.push(
            <img
              key={index}
              src={imageSrc}
              alt="Image"
              style={{
                maxWidth: "100%",
                display: "inline",
                verticalAlign: "middle",
                marginLeft: "4px",
                marginRight: "4px",
                maxHeight: "150px"
              }}
            />
          );
        } else if (alignContent) {
          parts.push(
            <BlockMath
              key={index}
              style={{
                display: "block",
                textAlign: "center",
                margin: "10px 0",
                whiteSpace: "pre-line",
                overflowX: "auto"
              }}
            >
              {`\\begin{align}${alignContent}\\end{align}`}
            </BlockMath>
          );
        } else if (inlineLatex || blockLatex) {
          parts.push(
            <InlineMath
              key={index}
              style={{
                display: "inline",
                verticalAlign: "middle",
                marginLeft: "4px",
                marginRight: "4px"
              }}
            >
              {inlineLatex || blockLatex}
            </InlineMath>
          );
        }

        lastIndex = index + match.length;
      }
    );

    if (lastIndex < decodedText.length) {
      parts.push(decodedText.slice(lastIndex));
    }

    return <span style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>;
  };

  const subjectOptions = subjects.map((subject) => ({
    value: subject.id,
    label: `${subject.subjectName} (${subject.subjectCount})`,
  }));

  const chapterOptions = chapters.map((chapter) => {

    const subjectName =
      subjects.find(
        (s) => String(s.id) === String(chapter.subjectId)
      )?.subjectName || "";

    return {
      value: chapter.id,

      subjectId: chapter.subjectId,

      label: `${chapter.chapterName}`,
    };
  });

  const topicOptions = topics.map((topic) => {

    const chapterName =
      chapters.find(
        (c) => String(c.id) === String(topic.chapterId)
      )?.chapterName || "";

    return {
      value: topic.id,
      label: `${topic.topicName} - ${chapterName} (${topic.topicCount})`,
    };
  });

  const levelOptions = levels.map((level) => ({
    value: level.id,
    label: level.levelName.trim(),
  }));

  const handleSubjectChange = (selectedOptions) => {
    const values = selectedOptions ? selectedOptions.map(opt => String(opt.value)) : [];
    setSelectedSubject(values);
  };

  const handleChapterChange = (selectedOptions) => {
    const values = selectedOptions ? selectedOptions.map(opt => String(opt.value)) : [];
    setSelectedChapter(values);
  };

  const handleTopicChange = (selectedOptions) => {
    const values = selectedOptions ? selectedOptions.map(opt => String(opt.value)) : [];
    setSelectedTopic(values);
  };

  const handleLevelChange = (
    subjectId,
    levelId,
    value
  ) => {

    setSubjectConfigs((prev) =>
      prev.map((item) =>
        item.subjectId === subjectId
          ? {
            ...item,

            levels: {
              ...item.levels,

              [levelId]: Number(value),
            },
          }
          : item
      )
    );

  };

  const toggleChapters = (subjectId) => {

    setSubjectConfigs((prev) =>
      prev.map((item) =>
        item.subjectId === subjectId
          ? {
            ...item,

            showChapters:
              !item.showChapters,
          }
          : item
      )
    );

  };

  const toggleTopics = (subjectId) => {

    setSubjectConfigs((prev) =>
      prev.map((item) =>
        item.subjectId === subjectId
          ? {
            ...item,

            showTopics:
              !item.showTopics,
          }
          : item
      )
    );

  };

  const handleChapterSelection = async (
    subjectId,
    selected
  ) => {

    const chapterIds =
      selected?.map(
        (item) => Number(item.value)
      ) || [];

    setSubjectConfigs((prev) =>
      prev.map((item) =>
        item.subjectId === subjectId
          ? {
            ...item,
            chapters: chapterIds,
            topics: [],
          }
          : item
      )
    );

    // Fetch topics for this subject + selected chapters

    if (chapterIds.length > 0) {
      await fetchTopics(
        [subjectId],
        chapterIds
      );
    }
  };

  const handleTopicSelection = (
    subjectId,
    selected
  ) => {

    const topicIds =
      selected?.map(
        (item) => Number(item.value)
      ) || [];

    setSubjectConfigs((prev) =>
      prev.map((item) =>
        item.subjectId === subjectId
          ? {
            ...item,

            topics: topicIds,
          }
          : item
      )
    );

  };

  const clearFilters = () => {
    setSelectedSubject([]);
    setSelectedChapter([]);
    setSelectedTopic([]);
    setSelectedLevel([]);
    setQuestions([]);
    setQuestionIds([]);
    setSelectedQuestionTypes([]);
  };

  const canGenerate = selectedSubject.length > 0 && selectedChapter.length > 0 && selectedTopic.length > 0;

  const thStyle = {
    border: "1px solid #dee2e6",
    padding: "12px",
    textAlign: "left",
    fontWeight: "600",
  };

  const tdStyle = {
    border: "1px solid #dee2e6",
    padding: "12px",
  };


  const getLevelTotal = (subject) => {
    return Object.values(subject.levels || {}).reduce(
      (sum, value) => sum + Number(value || 0),
      0
    );
  };

  const areAllLevelPercentagesValid = subjectConfigs.every((subject) => {
    const total = getLevelTotal(subject);

    // Allow completely empty distribution
    if (total === 0) return true;

    // Otherwise must be exactly 100
    return total === 100;
  });

  return (
    <div style={{
      padding: "24px",


      paddingBottom: questions.length > 0 ? "100px" : "24px",
      minHeight: "100vh"
    }}>


      {/* Header */}
      <div style={{ marginBottom: "32px", display: "flex", justifyContent: "space-between" }}>
        <h2 style={{
          fontSize: "28px",
          fontWeight: "600",
          color: "#2c3e50",
          marginBottom: "8px"
        }}>
          Generate Random Questions
        </h2>

        <Button
          variant="primary"
          onClick={() => navigate(`/view-questions/${id}`)}

        >
          Preview
        </Button>


      </div>



      <div
        style={{
          marginBottom: "32px",
          background: "#fff",
          borderRadius: "12px",
          padding: "20px",
          overflow: "visible", // change from hidden
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          position: "relative",
          zIndex: 1,
        }}
      >

        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            flexWrap: "wrap",
          }}
        >
          <div>
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "700",
                margin: 0,
                color: "#1e293b",
              }}
            >
              Section Wise Distribution
            </h3>
          </div>

          <div
            style={{
              background: "#f1f5f9",
              padding: "8px 14px",
              borderRadius: "10px",
              fontSize: "13px",
              fontWeight: "600",
              color: "#334155",
            }}
          >
            Sections: {templateSections.length}
          </div>
        </div>

        {templateSections.map((section) => {
          const rows = distributionRows.filter(
            (r) => r.sectionNumber === section.sectionNumber
          );

          const groupedSubjects = {};

          rows.forEach((row) => {
            if (!groupedSubjects[row.subjectId]) {
              groupedSubjects[row.subjectId] = {
                subjectName: row.subjectName,
                levels: [],
              };
            }
            groupedSubjects[row.subjectId].levels.push(row);
          });

          return (
            <div
              key={section.sectionNumber}
              style={{
                marginBottom: "32px",
                background: "#fff",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              {/* Section Header */}
              <div
                style={{
                  background: "#1a1a2e",
                  padding: "16px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    color: "#fff",
                    fontWeight: "600",
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <span
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      padding: "4px 12px",
                      borderRadius: "20px",
                      fontSize: "14px",
                    }}
                  >
                    Section {section.sectionNumber}
                  </span>

                </div>
                <div
                  style={{
                    color: "#fff",
                    fontSize: "13px",
                    background: "rgba(255,255,255,0.15)",
                    padding: "6px 14px",
                    borderRadius: "20px",
                  }}
                >
                  Total: {section.totalQuestions || 0} Questions
                </div>
              </div>

              {/* Table */}
              <div style={{ overflowX: "auto", padding: "0" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "14px",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        background: "#f8f9fa",
                        borderBottom: "2px solid #e9ecef",
                      }}
                    >
                      <th
                        style={{
                          padding: "14px 16px",
                          textAlign: "left",
                          fontWeight: "600",
                          color: "#495057",
                          minWidth: "180px",
                        }}
                      >
                        Subject
                      </th>
                      {levels.map((level) => (
                        <th
                          key={level.id}
                          style={{
                            padding: "14px 8px",
                            textAlign: "center",
                            fontWeight: "600",
                            color: "#495057",
                            minWidth: "100px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <span>{level.levelName} %</span>

                          </div>
                        </th>
                      ))}
                      <th
                        style={{
                          padding: "14px 16px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#495057",
                          minWidth: "120px",
                        }}
                      >
                        Total
                      </th>
                      <th
                        style={{
                          padding: "14px 16px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#495057",
                          minWidth: "120px",
                        }}
                      >
                        Chapters
                      </th>

                    </tr>
                  </thead>

                  <tbody>
                    {subjectConfigs
                      .filter(
                        (subject) =>
                          String(subject.sectionNumber) === String(section.sectionNumber)
                      )
                      .map((subject, idx) => (
                        <React.Fragment key={subject.subjectId}>
                          <tr
                            style={{
                              borderBottom: "1px solid #e9ecef",
                              background: idx % 2 === 0 ? "#fff" : "#fefefe",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#f8f9fa";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = idx % 2 === 0 ? "#fff" : "#fefefe";
                            }}
                          >
                            {/* Subject Name */}
                            <td
                              style={{
                                padding: "14px 16px",
                                fontWeight: "500",
                                color: "#2c3e50",
                                borderRight: "1px solid #f0f0f0",
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <span
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    background: "#4a90e2",
                                    borderRadius: "50%",
                                    display: "inline-block",
                                  }}
                                />
                                {subject.subjectName}
                              </div>
                            </td>

                            {/* Level Inputs */}
                            {levels.map((level) => (
                              <td
                                key={level.id}
                                style={{
                                  padding: "10px 8px",
                                  textAlign: "center",
                                }}
                              >
                                <input
                                  type="number"
                                  min="0"
                                  max="100"
                                  step="1"
                                  placeholder="0"
                                  value={subject.levels[level.id] || ""}
                                  onChange={(e) =>
                                    handleLevelChange(
                                      subject.subjectId,
                                      level.id,
                                      e.target.value
                                    )
                                  }
                                  style={{
                                    width: "80px",
                                    padding: "8px 6px",
                                    border: "1px solid #dee2e6",
                                    borderRadius: "6px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    transition: "all 0.2s",
                                    outline: "none",
                                  }}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = "#4a90e2";
                                    e.target.style.boxShadow = "0 0 0 2px rgba(74,144,226,0.1)";
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = "#dee2e6";
                                    e.target.style.boxShadow = "none";
                                  }}
                                />
                              </td>
                            ))}

                            {/* Total Questions */}
                            <td
                              style={{
                                padding: "10px 16px",
                                textAlign: "center",
                              }}
                            >
                              <input
                                type="number"
                                value={subject.totalQuestions}
                                disabled
                                style={{
                                  width: "100%",
                                  maxWidth: "90px",
                                  padding: "8px 6px",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "6px",
                                  textAlign: "center",
                                  background: "#f1f5f9",
                                  fontWeight: "700",
                                  color: "#0f172a",
                                }}
                              />
                              {/* <div
                                style={{
                                  marginTop: "6px",
                                  fontSize: "12px",
                               
                                  color:
                                    getLevelTotal(subject) === 0
                                      ? "#64748b"
                                      : getLevelTotal(subject) === 100
                                        ? "#16a34a"
                                        : "#dc2626",
                                }}
                              >
                                {getLevelTotal(subject)}%
                              </div> */}
                            </td>

                            {/* Chapters Button */}
                            <td
                              style={{
                                padding: "10px 16px",
                                textAlign: "center",
                              }}
                            >
                              <button
                                type="button"
                                onClick={() => {
                                  if (!subject.showChapters) {
                                    toggleChapters(subject.subjectId);
                                  }
                                }}
                                style={{
                                  background: subject.showChapters
                                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                    : "#f8f9fa",
                                  color: subject.showChapters ? "#fff" : "#495057",
                                  border: subject.showChapters ? "none" : "1px solid #dee2e6",
                                  padding: "6px 14px",
                                  borderRadius: "6px",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  transition: "all 0.2s",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                                onMouseEnter={(e) => {
                                  if (!subject.showChapters) {
                                    e.target.style.background = "#e9ecef";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!subject.showChapters) {
                                    e.target.style.background = "#f8f9fa";
                                  }
                                }}
                              >
                                <span>📚</span>
                                {subject.chapters.length > 0
                                  ? `${subject.chapters.length} Selected`
                                  : "Add Chapters"}
                              </button>
                            </td>

                            {/* Topics Button */}
                            {/* <td
                              style={{
                                padding: "10px 16px",
                                textAlign: "center",
                              }}
                            >
                              <button
                                type="button"
                                onClick={() => {
                                  if (!subject.showTopics) {
                                    toggleTopics(subject.subjectId);
                                  }
                                }}
                                style={{
                                  background: subject.showTopics
                                    ? "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
                                    : "#f8f9fa",
                                  color: subject.showTopics ? "#fff" : "#495057",
                                  border: subject.showTopics ? "none" : "1px solid #dee2e6",
                                  padding: "6px 14px",
                                  borderRadius: "6px",
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  transition: "all 0.2s",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                                onMouseEnter={(e) => {
                                  if (!subject.showTopics) {
                                    e.target.style.background = "#e9ecef";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!subject.showTopics) {
                                    e.target.style.background = "#f8f9fa";
                                  }
                                }}
                              >
                                <span>🏷️</span>
                                {subject.topics.length > 0
                                  ? `${subject.topics.length} Selected`
                                  : "Add Topics"}
                              </button>
                            </td> */}
                          </tr>

                          {/* 3. Replace BOTH your existing {subject.showChapters && (...)} and {subject.showTopics && (...)} blocks with this single updated block */}

                          {/* Chapters & Nested Topics Dropdown Row */}
                          {subject.showChapters && (
                            <tr>
                              <td
                                colSpan={levels.length + 4}
                                style={{
                                  padding: "16px 20px",
                                  background: "#f8f9fa",
                                  borderBottom: "1px solid #e9ecef",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    flexWrap: "wrap",
                                    marginBottom: subject.chapters.length > 0 ? "16px" : "0",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "600",
                                      color: "#495057",
                                      minWidth: "70px",
                                    }}
                                  >
                                    Select Chapters:
                                  </span>
                                  <div style={{ flex: 1, minWidth: "250px" }}>
                                    <Select
                                      isMulti
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      placeholder="Choose chapters..."
                                      options={chapterOptions.filter(
                                        (chapter) =>
                                          String(chapter.subjectId) === String(subject.subjectId)
                                      )}
                                      value={chapterOptions.filter(opt => subject.chapters.includes(Number(opt.value)))}
                                      onChange={(selected) =>
                                        handleChapterSelection(subject.subjectId, selected)
                                      }
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                                        menu: (base) => ({ ...base, zIndex: 999999 }),
                                        control: (base) => ({
                                          ...base,
                                          minHeight: "42px",
                                          borderRadius: "8px",
                                          borderColor: "#dee2e6",
                                          boxShadow: "none",
                                          "&:hover": { borderColor: "#4a90e2" },
                                        }),
                                      }}
                                    />
                                  </div>
                                </div>

                                {/* Vertical Chapter List with Toggleable Topics */}
                                {subject.chapters.length > 0 && (
                                  <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "12px" }}>
                                    {subject.chapters.map(chapterId => {
                                      const chapterObj = chapterOptions.find(c => Number(c.value) === chapterId);
                                      const isExpanded = expandedChapters[chapterId];

                                      const chapterTopics = (topicsBySubject[subject.subjectId] || [])
                                        .filter(t => Number(t.chapterId) === chapterId);

                                      const selectedTopicOptions = chapterTopics
                                        .filter(t => subject.topics.includes(Number(t.id)))
                                        .map(t => ({ value: t.id, label: t.topicName }));

                                      return (
                                        <div key={chapterId} style={{ border: "1px solid #dee2e6", borderRadius: "8px", overflow: "hidden", background: "#fff" }}>

                                          <div
                                            onClick={() => toggleChapterExpansion(chapterId)}
                                            style={{
                                              padding: "12px 16px",
                                              background: isExpanded ? "#e9ecef" : "#fff",
                                              cursor: "pointer",
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              fontWeight: "600",
                                              color: "#2c3e50",
                                              transition: "background 0.2s"
                                            }}
                                          >
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                              <span>📚</span>
                                              {/* Split by ' - ' to remove the appended subject name in the label */}
                                              {chapterObj?.label.split(' - ')[0]}
                                              {selectedTopicOptions.length > 0 && (
                                                <span style={{ fontSize: "11px", background: "#f8d7da", color: "#dc3545", padding: "2px 8px", borderRadius: "12px", marginLeft: "8px" }}>
                                                  {selectedTopicOptions.length} Topics
                                                </span>
                                              )}
                                            </div>
                                            <span style={{ fontSize: "12px", color: "#6c757d", transition: "transform 0.2s", transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)" }}>
                                              ▼
                                            </span>
                                          </div>

                                          {isExpanded && (
                                            <div style={{ padding: "16px", borderTop: "1px solid #dee2e6", background: "#fafbfc" }}>
                                              <span style={{ fontSize: "13px", fontWeight: "600", color: "#495057", display: "block", marginBottom: "8px" }}>
                                                Select Topics for this Chapter:
                                              </span>
                                              <Select
                                                isMulti
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                placeholder={chapterTopics.length === 0 ? "No topics available" : "Choose topics..."}
                                                isDisabled={chapterTopics.length === 0}
                                                options={chapterTopics.map((topic) => ({
                                                  value: topic.id,
                                                  label: topic.topicName,
                                                }))}
                                                value={selectedTopicOptions}
                                                onChange={(selected) =>
                                                  handleNestedTopicSelection(subject.subjectId, chapterId, selected)
                                                }
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                                                  menu: (base) => ({ ...base, zIndex: 999999 }),
                                                  control: (base) => ({
                                                    ...base,
                                                    minHeight: "42px",
                                                    borderRadius: "8px",
                                                    borderColor: "#dee2e6",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#f5576c" },
                                                  }),
                                                }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}

        {/* FOOTER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >

          <div
            style={{
              marginBottom: "12px",
              color: "#dc2626",
              fontSize: "13px",
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            {!areAllLevelPercentagesValid && (
              <p>For any subject where levels are entered, the total must be 100%.</p>
            )}
          </div>

          <Button
            variant="primary"
            onClick={fetchRandomQuestions}
            disabled={
              isGenerating ||
              !areAllLevelPercentagesValid
            }
            style={{
              height: "44px",
              padding: "0 22px",
              borderRadius: "10px",
              fontWeight: "600",
              fontSize: "14px",
              border: "none",
              background:
                "linear-gradient(90deg, #0ea5e9 0%, #0284c7 100%)",
              boxShadow:
                "0 4px 12px rgba(14,165,233,0.3)",
            }}
          >
            {isGenerating ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    marginRight: "8px",
                  }}
                />
                Generating...
              </>
            ) : (
              "Generate Questions"
            )}
          </Button>
        </div>
      </div>

      {/* WARNINGS */}

      {warnings.length > 0 && (

        <div
          style={{
            background: "#fff7ed",
            border: "1px solid #fdba74",
            borderRadius: "12px",
            padding: "16px 18px",
            marginBottom: "18px",
          }}
        >

          {/* HEADER */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "14px",
            }}
          >

            <div
              style={{
                width: "34px",
                height: "34px",
                borderRadius: "50%",
                background: "#fb923c",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                fontWeight: "700",
              }}
            >
              !
            </div>

            <div>

              <div
                style={{
                  fontSize: "17px",
                  fontWeight: "700",
                  color: "#9a3412",
                }}
              >
                Generation Warnings
              </div>

              <div
                style={{
                  fontSize: "13px",
                  color: "#c2410c",
                  marginTop: "2px",
                }}
              >
                Some requested questions were unavailable
              </div>

            </div>

          </div>

          {/* WARNINGS LIST */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >

            {warnings.map((warning, index) => (

              <div
                key={index}
                style={{
                  background: "#fff",
                  border: "1px solid #fed7aa",
                  borderRadius: "10px",
                  padding: "12px 14px",
                  color: "#7c2d12",
                  fontSize: "13px",
                  fontWeight: "500",
                  lineHeight: "1.5",
                }}
              >
                {warning}
              </div>

            ))}

          </div>

        </div>

      )}

      {/* COMPACT QUESTION SUMMARY */}

      {questionTypeSummary.length > 0 && (

        <div
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: "10px",
            padding: "12px 16px",
            marginBottom: "18px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >

          {questionTypeSummary.map((item, index) => {

            const questionTypeName =
              questionTypes.find(
                (qt) =>
                  String(qt.id) ===
                  String(item.questionType)
              )?.questionType || "Question";

            return (

              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "12px",
                }}
              >

                {/* LEFT */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >

                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "700",
                      color: "#0f172a",
                    }}
                  >
                    {questionTypeName}
                  </div>

                  <div
                    style={{
                      background: "#dcfce7",
                      color: "#166534",
                      padding: "4px 10px",
                      borderRadius: "999px",
                      fontSize: "11px",
                      fontWeight: "700",
                    }}
                  >
                    {item.totalQuestions} Questions
                  </div>

                </div>

                {/* SUBJECTS */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >

                  {item.subjects?.map((subject, idx) => (

                    <div
                      key={idx}
                      style={{
                        background: "#eff6ff",
                        color: "#1d4ed8",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        fontSize: "11px",
                        fontWeight: "600",
                      }}
                    >
                      {subject.subjectName.trim()} ({subject.count})
                    </div>

                  ))}

                </div>

                {/* LEVELS */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >

                  {item.levels?.map((level, idx) => (

                    <div
                      key={idx}
                      style={{
                        background: "#faf5ff",
                        color: "#7e22ce",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        fontSize: "11px",
                        fontWeight: "600",
                      }}
                    >
                      {level.levelName} ({level.count})
                    </div>

                  ))}

                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "12px",
                  }}
                >

                  <button
                    onClick={() =>
                      setShowChapterSummaryModal(true)
                    }
                    disabled={
                      chapterWiseSummary.length === 0
                    }
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "50%",
                      border: "none",
                      background:
                        chapterWiseSummary.length === 0
                          ? "#cbd5e1"
                          : "#0f172a",

                      color: "#fff",

                      fontWeight: "700",

                      fontSize: "15px",

                      cursor:
                        chapterWiseSummary.length === 0
                          ? "not-allowed"
                          : "pointer",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      boxShadow:
                        "0 2px 8px rgba(0,0,0,0.15)",
                    }}
                  >
                    i
                  </button>

                </div>

              </div>

            );
          })}

        </div>

      )}
      {/* Questions Section */}
      {questions.length > 0 && (
        <div style={{
          background: "white",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          overflow: "hidden"
        }}>
          {/* Questions Header */}
          <div style={{
            padding: "20px 24px",
            background: "#f8f9fa",
            borderBottom: "1px solid #e9ecef",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            <h3 style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#2c3e50",
              margin: "0"
            }}>
              Generated Questions <span style={{ color: "#3498db", fontWeight: "500" }}>({questions.length})</span>
            </h3>
            <div>
              <Button
                variant="outline-primary"
                onClick={fetchRandomQuestions}
                disabled={isGenerating}
                size="sm"
              >
                <i className="ph ph-arrows-clockwise" style={{ marginRight: "4px" }}></i> Regenerate
              </Button>
            </div>
          </div>

          {/* Questions List */}
          {/* QUESTIONS SECTION WISE */}

          <div style={{ padding: "24px" }}>

            {Object.entries(

              questions.reduce((acc, question) => {

                const sectionKey =
                  question.sectionId || "0";

                if (!acc[sectionKey]) {

                  acc[sectionKey] = {
                    sectionName:
                      question.sectionName ||
                      `Section ${sectionKey}`,

                    questions: [],
                  };
                }

                acc[sectionKey].questions.push(question);

                return acc;

              }, {})

            ).map(([sectionId, sectionData]) => (

              <div
                key={sectionId}
                style={{
                  marginBottom: "40px",
                }}
              >

                {/* SECTION HEADER */}

                <div
                  style={{
                    background:
                      "linear-gradient(90deg, #0f172a 0%, #1e293b 100%)",

                    padding: "14px 18px",

                    borderRadius: "10px",

                    marginBottom: "20px",

                    display: "flex",

                    justifyContent: "space-between",

                    alignItems: "center",

                    flexWrap: "wrap",

                    gap: "10px",
                  }}
                >

                  <div
                    style={{
                      color: "#fff",
                      fontSize: "18px",
                      fontWeight: "700",
                    }}
                  >
                    {sectionData.sectionName}
                  </div>

                  <div
                    style={{
                      background: "#dbeafe",
                      color: "#1d4ed8",
                      padding: "6px 12px",
                      borderRadius: "999px",
                      fontSize: "12px",
                      fontWeight: "700",
                    }}
                  >
                    {sectionData.questions.length} Questions
                  </div>

                </div>

                {/* QUESTIONS */}

                {sectionData.questions.map(
                  (question, index) => (
                    <div key={question.id} style={{
                      background: "white",
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      padding: "20px",
                      marginBottom: "20px",
                      transition: "box-shadow 0.2s",
                      "&:hover": {
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                      }
                    }}>
                      {prevPapers[question.id]?.length > 0 && (
                        <div
                          style={{
                            marginTop: "10px",
                            padding: "10px",
                            background: "#f8fafc",
                            border: "1px solid #e2e8f0",
                            borderRadius: "8px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 600,
                              marginBottom: "8px",
                            }}
                          >
                            Previously Used In
                          </div>

                          {prevPapers[question.id].map((paper, idx) => (
                            <div
                              key={idx}
                              style={{
                                padding: "6px 0",
                                borderBottom:
                                  idx !== prevPapers[question.id].length - 1
                                    ? "1px solid #eee"
                                    : "none",
                              }}
                            >
                              {paper.paperName}
                            </div>
                          ))}
                        </div>
                      )}
                      {/* Question Header */}
                      <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "16px",
                        paddingBottom: "12px",
                        borderBottom: "1px solid #f1f2f3"
                      }}>



                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                          <span style={{
                            background: "#e8f5e8",
                            color: "#27ae60",
                            padding: "4px 12px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "500"
                          }}>
                            {question.levelName}
                          </span>
                          <span style={{
                            background: "#fee",
                            color: "#e74c3c",
                            padding: "4px 12px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "500"
                          }}>
                            {question.examType}
                          </span>
                          <span style={{
                            background: "#fff3cd",
                            color: "#856404",
                            padding: "4px 12px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "500"
                          }}>
                            ID: {question.id}
                          </span>

                          {Number(question.usedCount) > 0 && (
                            <span
                              onClick={() => handleFetchPrev(question.id)}
                              style={{
                                background: "#e0f2fe",
                                color: "#0369a1",
                                padding: "4px 12px",
                                borderRadius: "16px",
                                fontSize: "12px",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                cursor: "pointer",
                              }}
                            >
                              <FiClock size={12} />
                              {question.usedCount}
                            </span>
                          )}

                          <div>
                            {question.tags && (
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "6px",

                                }}
                              >
                                {question.tags.split(",").map((tag, idx) => (
                                  <span
                                    key={idx}
                                    style={{
                                      background: "#ecfdf5",
                                      color: "#065f46",
                                      border: "1px solid #a7f3d0",
                                      borderRadius: "999px",
                                      padding: "4px 10px",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {tag.trim()}
                                  </span>
                                ))}
                              </div>
                            )}

                          </div>
                        </div>


                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#7f8c8d"
                          }}
                        >
                          Question {index + 1}
                        </div>


                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              marginRight: "10px"
                            }}
                          >

                            <button
                              onClick={() =>
                                handleReplaceQuestion(
                                  question.id,
                                  index
                                )
                              }
                              disabled={
                                replacingId === question.id
                              }
                              style={{
                                background: "#FFF3CD",
                                border: "none",
                                color: "#000",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                fontSize: "13px",
                                fontWeight: "500",
                                cursor:
                                  replacingId === question.id
                                    ? "not-allowed"
                                    : "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >

                              {replacingId === question.id ? (
                                <>
                                  <span
                                    style={{
                                      width: "14px",
                                      height: "14px",
                                      border:
                                        "2px solid #fff",
                                      borderTop:
                                        "2px solid transparent",
                                      borderRadius: "50%",
                                      display: "inline-block",
                                      animation:
                                        "spin 0.6s linear infinite"
                                    }}
                                  />

                                  Replacing...
                                </>
                              ) : (
                                "🔁 Replace"
                              )}

                            </button>


                          </div>

                       <button
  onClick={() => {
    setEditingQuestionId(question.id);
    setShowEditModal(true);
  }}
  style={{
    background: "#DBEAFE",
    border: "none",
    color: "#1D4ED8",
    padding: "6px 12px",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  }}
>
  ✏️ Edit
</button>
                        </div>
                      </div>

                      {/* Question Content */}
                      <div style={{ marginBottom: "20px" }}>
                        {renderLatexText(question.question)}
                      </div>

                      {/* Options or Answer Placeholder */}
                      {question.options && question.options.length > 0 ? (
                        <>
                          <div style={{
                            fontWeight: "600",
                            marginBottom: "12px",
                            color: "#2c3e50"
                          }}>
                            Options:
                          </div>
                          <div style={{
                            display: "grid",
                            gridTemplateColumns: question.options.some(opt => opt.length > 50) ? "1fr" : "repeat(2, 1fr)",
                            gap: "12px"
                          }}>
                            {question.options.map((option, idx) => (
                              <div key={idx} style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "8px",
                                padding: "8px 12px",
                                background: "#f8f9fa",
                                borderRadius: "6px",
                                border: "1px solid #e9ecef"
                              }}>
                                <span style={{
                                  fontWeight: "600",
                                  color: "#3498db",
                                  minWidth: "24px"
                                }}>
                                  {String.fromCharCode(65 + idx)}.
                                </span>
                                <span style={{ flex: 1 }}>
                                  {renderLatexText(option)}
                                </span>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <div style={{
                          padding: "16px",
                          background: "#f8f9fa",
                          borderRadius: "8px",
                          border: "1px dashed #dee2e6",
                          textAlign: "center",
                          color: "#6c757d",
                          fontWeight: "500",
                          fontSize: "16px"
                        }}>
                          Answer: _ _ _ _ _ _ _
                        </div>
                      )}
                    </div>
                  ))
                }

              </div>

            ))}

          </div>
        </div>

      )}

      {/* Fixed Bottom Button Bar */}
      {questions.length > 0 && (
        <div style={{
          position: "fixed",
          bottom: "0",
          left: "0",
          right: "0",
          background: "white",
          borderTop: "1px solid #e9ecef",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          padding: "16px 24px",
          zIndex: 1000
        }}>
          <div style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            <div style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#2c3e50"
            }}>
              {questions.length} question{questions.length !== 1 ? 's' : ''} selected
            </div>
            <div style={{ display: "flex", gap: "12px" }}>
              <Button
                variant="outline-secondary"
                onClick={clearFilters}
                style={{ minWidth: "100px" }}
              >
                Cancel
              </Button>
              <Button
                variant="success"
                onClick={handleSubmit}
                disabled={submitting || questionIds.length === 0}
                style={{ minWidth: "140px", fontWeight: "600" }}
              >
                {submitting ? (
                  <>
                    <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                    Submitting...
                  </>
                ) : (
                  'Submit Questions'
                )}
              </Button>
            </div>
          </div>
        </div>
      )}

      {showEditModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            width: "100%",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 9999,
            overflowY: "auto",
            padding: "40px 20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "1200px",
              minHeight: "fit-content",
              padding: "20px",
              position: "relative",
              marginBottom: "40px",
              overflow: "visible",
            }}
          >
            <button
              onClick={() => setShowEditModal(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                border: "none",
                background: "transparent",
                fontSize: "28px",
                cursor: "pointer",
              }}
            >
              ×
            </button>

            <AddQuestion
              id={editingQuestionId}
              onSuccess={handleCloseEdit}
            />
          </div>
        </div>
      )}

      {showDistributionModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            zIndex: 99999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "1200px",
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "24px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: "600",
                }}
              >
                Question Distribution
              </h3>

              <button
                onClick={() => setShowDistributionModal(false)}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "28px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>

            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                padding: "0",
                position: "relative",
                zIndex: 1,
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "#f8f9fa",
                    }}
                  >
                    <th style={thStyle}>Subject</th>
                    <th style={thStyle}>Chapter</th>
                    <th style={thStyle}>Topic</th>
                    <th style={thStyle}>Count</th>
                    <th style={thStyle}>Level</th>
                    <th style={thStyle}>Question Type</th>
                  </tr>
                </thead>

                <tbody>
                  {distributionData.map((item, index) => {

                    const subjectName =
                      subjects.find(
                        (s) => String(s.id) === String(item.subjectId)
                      )?.subjectName || "-";

                    const chapterName =
                      chapters.find(
                        (c) => String(c.id) === String(item.chapterId)
                      )?.chapterName || "-";

                    const topicName =
                      topics.find(
                        (t) => String(t.id) === String(item.topicId)
                      )?.topicName || "-";

                    return (
                      <tr key={index}>
                        <td style={tdStyle}>{subjectName}</td>

                        <td style={tdStyle}>{chapterName}</td>

                        <td style={tdStyle}>{topicName}</td>

                        <td style={tdStyle}>
                          <input
                            type="number"
                            min="1"
                            value={item.count}
                            onChange={(e) =>
                              handleDistributionCountChange(
                                index,
                                e.target.value
                              )
                            }
                            style={{
                              width: "80px",
                              padding: "8px",
                              borderRadius: "6px",
                              border: "1px solid #ccc",
                            }}
                          />
                        </td>

                        <td style={tdStyle}>
                          {levels
                            .filter((lvl) =>
                              item.levelId.includes(String(lvl.id))
                            )
                            .map((lvl) => lvl.levelName)
                            .join(", ")}
                        </td>

                        <td style={tdStyle}>
                          {questionTypes
                            .filter((qt) =>
                              item.questionType.includes(String(qt.id))
                            )
                            .map((qt) => qt.questionType)
                            .join(", ")}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div
              style={{
                marginTop: "24px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <Button
                variant="secondary"
                onClick={() => setShowDistributionModal(false)}
              >
                Cancel
              </Button>

              <Button
                variant="primary"
                onClick={fetchRandomQuestions}
                disabled={isGenerating}
              >
                {isGenerating ? "Generating..." : "Generate Questions"}
              </Button>
            </div>
          </div>
        </div>
      )}

      {showChapterSummaryModal && (

        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            zIndex: 99999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >

          <div
            style={{
              background: "#fff",
              borderRadius: "14px",
              width: "100%",
              maxWidth: "1100px",
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "24px",
            }}
          >

            {/* HEADER */}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >

              <h3
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#0f172a",
                }}
              >
                Chapter Wise Summary
              </h3>

              <button
                onClick={() =>
                  setShowChapterSummaryModal(false)
                }
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "28px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>

            </div>

            {/* SUBJECTS */}

            {chapterWiseSummary.map(
              (subject, subjectIndex) => (

                <div
                  key={subjectIndex}
                  style={{
                    marginBottom: "24px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    overflow: "hidden",
                  }}
                >

                  {/* SUBJECT HEADER */}

                  <div
                    style={{
                      background: "#eff6ff",
                      padding: "14px 18px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "12px",
                    }}
                  >

                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "#1e3a8a",
                      }}
                    >
                      {subject.subjectName}
                    </div>

                    <div
                      style={{
                        background: "#dbeafe",
                        color: "#1d4ed8",
                        padding: "6px 12px",
                        borderRadius: "999px",
                        fontSize: "12px",
                        fontWeight: "700",
                      }}
                    >
                      {subject.totalQuestions} Questions
                    </div>

                  </div>

                  {/* TABLE */}

                  <div style={{ overflowX: "auto" }}>

                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >

                      <thead>

                        <tr
                          style={{
                            background: "#f8fafc",
                          }}
                        >

                          <th style={thStyle}>
                            Chapter
                          </th>

                          <th style={thStyle}>
                            Total
                          </th>

                          <th style={thStyle}>
                            Levels
                          </th>

                          <th style={thStyle}>
                            Question Types
                          </th>

                        </tr>

                      </thead>

                      <tbody>

                        {subject.chapters?.map(
                          (chapter, chapterIndex) => {

                            return (

                              <tr key={chapterIndex}>

                                <td style={tdStyle}>
                                  {chapter.chapterName}
                                </td>

                                <td style={tdStyle}>
                                  <div
                                    style={{
                                      background: "#dcfce7",
                                      color: "#166534",
                                      padding: "4px 10px",
                                      borderRadius: "999px",
                                      display: "inline-block",
                                      fontSize: "12px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {
                                      chapter.totalQuestions
                                    }
                                  </div>
                                </td>

                                {/* LEVELS */}

                                <td style={tdStyle}>

                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "8px",
                                      flexWrap: "wrap",
                                    }}
                                  >

                                    {chapter.levelWise?.map(
                                      (
                                        level,
                                        levelIndex
                                      ) => (

                                        <div
                                          key={levelIndex}
                                          style={{
                                            background:
                                              "#faf5ff",

                                            color:
                                              "#7e22ce",

                                            padding:
                                              "4px 8px",

                                            borderRadius:
                                              "6px",

                                            fontSize:
                                              "11px",

                                            fontWeight:
                                              "600",
                                          }}
                                        >
                                          {
                                            level.levelName
                                          }{" "}
                                          (
                                          {
                                            level.count
                                          }
                                          )
                                        </div>

                                      )
                                    )}

                                  </div>

                                </td>

                                {/* QUESTION TYPES */}

                                <td style={tdStyle}>

                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "8px",
                                      flexWrap: "wrap",
                                    }}
                                  >

                                    {chapter.typeWise?.map(
                                      (
                                        type,
                                        typeIndex
                                      ) => {

                                        const questionTypeName =
                                          questionTypes.find(
                                            (
                                              qt
                                            ) =>
                                              String(
                                                qt.id
                                              ) ===
                                              String(
                                                type.questionType
                                              )
                                          )
                                            ?.questionType ||
                                          "Question";

                                        return (

                                          <div
                                            key={
                                              typeIndex
                                            }
                                            style={{
                                              background:
                                                "#eff6ff",

                                              color:
                                                "#1d4ed8",

                                              padding:
                                                "4px 8px",

                                              borderRadius:
                                                "6px",

                                              fontSize:
                                                "11px",

                                              fontWeight:
                                                "600",
                                            }}
                                          >
                                            {
                                              questionTypeName
                                            }{" "}
                                            (
                                            {
                                              type.count
                                            }
                                            )
                                          </div>

                                        );
                                      }
                                    )}

                                  </div>

                                </td>

                              </tr>

                            );
                          }
                        )}

                      </tbody>

                    </table>

                  </div>

                </div>

              )
            )}

          </div>

        </div>

      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ marginTop: "70px" }}
      />
    </div>
  );
};

export default Random;